import { settingApi } from '@/api'
import { SETTINGS_TYPES } from '@/constant'
import { SettingsService } from '@/services/SettingsService'

export interface SettingsParams {
  key: string
  value: string
  type: string
}

export const changeSetting = (
  params: SettingsParams,
  onSuccess: () => void,
  onDismiss: () => void,
): void => {
  settingApi
    .update(params)
    .then(
      (response: {
        status: number
        response?: { data: { message: string } }
      }) => {
        if (response.status === 200) {
          onSuccess()
          if (params.type === SETTINGS_TYPES.GENERAL) {
            const generalSettings = SettingsService.get(SETTINGS_TYPES.GENERAL)
            localStorage.setItem(
              SETTINGS_TYPES.GENERAL,
              JSON.stringify(
                Object.assign(generalSettings, { [params.key]: params.value }),
              ),
            )
          } else if (params.type === SETTINGS_TYPES.MENU) {
            const menuSettings = JSON.parse(
              localStorage.getItem(SETTINGS_TYPES.MENU_SETTINGS) ?? '{}',
            )
            localStorage.setItem(
              SETTINGS_TYPES.MENU_SETTINGS,
              JSON.stringify(
                Object.assign(menuSettings, { [params.key]: params.value }),
              ),
            )
          }
        } else {
          onDismiss()
        }
      },
    )
}

const updateTableOrdering = (
  ordering: string[],
  onSuccess: () => void,
  onDismiss: () => void,
) => {
  const params: SettingsParams = {
    key: 'studentsTableOrdering',
    value: JSON.stringify(ordering),
    type: SETTINGS_TYPES.GENERAL,
  }

  changeSetting(params, onSuccess, onDismiss)
}

export const updateTableHiddenColumns = (
  columns: Record<string, boolean>,
  onSuccess: () => void,
  onDismiss: () => void,
) => {
  const params: SettingsParams = {
    key: 'studentsTableHiddenColumns',
    value: JSON.stringify(columns),
    type: SETTINGS_TYPES.GENERAL,
  }

  changeSetting(params, onSuccess, onDismiss)
}

export default updateTableOrdering
